export default "__VITE_ASSET__COKTPqal__"